import Button, { ButtonProps } from './button';
import styles from './button.module.scss';

export default function ButtonBlock({ ref, ...props }: ButtonProps): JSX.Element {
  return <Button
    className={styles.button__block}
    {...props} />;
}
